import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, filter, map, Observable, skip } from 'rxjs';
import { HS_WINDOW } from './model/hubspot-window.model';

@Injectable({
  providedIn: 'root',
})
export class HubSpotService {
  private readonly router = inject(Router);
  public readonly window = inject(HS_WINDOW);

  public initialiseHubspot(user$: Observable<{ isImpersonating: boolean; userId: string }>) {
    // Hubspot automatically fires a trackPageView on pageload so we skip the first event to avoid doubling up
    const url$ = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.window.location.pathname),
      skip(1),
    );

    combineLatest({ user: user$, url: url$ }).subscribe(({ user, url }) => {
      if (this.trackUser(user.isImpersonating, user.userId)) {
        this.window._hsq.push(['setPath', url]);
        this.window._hsq.push(['trackPageView']);

        if (this.window.HubSpotCallsToActions) {
          this.window.HubSpotCallsToActions.refresh();
        }
      }
    });
  }

  public trackUser(isImpersonating: boolean, userId: string) {
    return !isImpersonating && !!userId;
  }
}
